import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init({
        plugins: [/*'zoom', */'video'],
        //zoom: true,
        video: true,
        mobileSettings: {
            controls: true
        }
    }
);

import * as dateInput from "@elements/date-input";
dateInput.init();

import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as toggleForm from "./scripts/toggle-form";
toggleForm.init();

import * as certificates from "./scripts/certificates";
certificates.init();

import * as advantagesPopup from "./scripts/advantages-popup";
advantagesPopup.init();

import * as accordion from "./scripts/accordion";
accordion.init();

import * as showMore from "./scripts/show-more";
showMore.init();

import * as tableSlider from "./scripts/table-slider";
tableSlider.init();

/*
import * as stickyBar from "./scripts/sticky-bar";
stickyBar.init();*/
